<template>
    <div id="header_bgColor" style="width: 100%; background-color: #fff">
        <div class="header">
            <div class="title">
                <img src="../../assets/img/images/logo.png" alt="" />
                <div class="title_info">
                    <div class="compName">北京普发动力控股股份有限公司</div>
                    <div class="compEng">BEIJING PROVA ENERGY HOLDING CO., LTD</div>
                </div>
                <div class="title_info cursors" @click="goToExternalLink">
                    <div class="compName" style="letter-spacing: .025rem; font-size: .275rem">SYNERGY</div>
                    <div class="compEng" style="font-size: .175rem;">普发动力意大利全资子公司</div>
                </div>
            </div>
            <div class="header-right">
                <div class="nav">
                    <el-menu :default-active="onRoutes" class="el-menu-demo" mode="horizontal" @select="handleSelect">
                        <el-menu-item v-for="item in headerMenus" :key="item.menuId" :index="item.type" :disabled="drawer">
                            {{ item.guideZw }}
                        </el-menu-item>
                    </el-menu>
                </div>
                <div style="width:1.75rem;">
                    <el-dropdown @command="handleCommand">
                        <div style="display:flex;align-items: center;">
                            <img src="../../assets/img/images/languageicon.png" alt="" style="width: .3rem;height: .3rem;margin-right: .0625rem;">
                            <div><span class="el-dropdown-link">{{ languageline }}<i class="el-icon-caret-bottom"></i> </span></div>
                        </div>
                        <el-dropdown-menu slot="dropdown">
                            <el-dropdown-item command="a" :class="checked1">中文（简体）</el-dropdown-item>
                            <el-dropdown-item command="b" :class="checked2" divided>English</el-dropdown-item>
                            <el-dropdown-item command="c" :class="checked3" divided>русский язык</el-dropdown-item>
                        </el-dropdown-menu>
                    </el-dropdown>
                </div>
                <!-- <div class="contactNum">
                    <div class="num">
                        <div class="numName">{{ serviceHotline }}：010-81215833</div>
                    </div>
                    <div class="language_box">
                        <span @click="languageTap(1)" :class="checked1">中文</span>
                        <span @click="languageTap(2)" :class="checked2">English</span>
                        <span @click="languageTap(3)" :class="checked3">русский язык</span>
                    </div>
                </div> -->
            </div>
        </div>
    </div>
</template>
<script>
import { gwGetMenuList } from '@/api/index';
export default {
    data() {
        return {
            languageType: '1',
            drawer: false,
            checked1: '',
            checked2: '',
            checked3: '',
            headerMenus: [],
            headerMenus_child: [],
            serviceHotline: '',
            languageline:""
        };
    },
    methods: {
        goToExternalLink() {
            const externalUrl = 'https://synergy-for-gas.com';
            window.location.href = externalUrl;
        },
        gotoviews(e) {
            if (e.type === 'product') {
                this.$router.push({
                    path: '/businessArea/product',
                    query: { params: e.order }
                    // query: {
                    //     params: e ,
                    //     order:e.order
                    // }
                });
            }
            if (e.type === 'operation') {
                this.$router.push({
                    path: '/businessArea/operation',
                    query: {
                        params: e,
                        order: e.order
                    }
                });
            }
        },
        handleSelect(key, keyPath) {
            this.$router.push('/' + keyPath);
            sessionStorage.removeItem('position_face');
            sessionStorage.removeItem('showInfosIndex');
        },
        handleCommand(command) {
            if (command == 'a') {
                this.resetSetItem('languageType', 1);
                this.languageline="中文"
            } else if (command == 'b') {
                this.resetSetItem('languageType', 2);
                this.languageline="English"
            } else if (command == 'c') {
                this.resetSetItem('languageType', 3);
                this.languageline="русский язык"
                // localStorage.setItem('languageType', 3);
            }
        },
        // languageTap(e) {
        //     //清除所有本地缓存
        //     // localStorage.clear();
        //     if (e == 1) {
        //         this.resetSetItem('languageType', 1);
        //     } else if (e == 2) {
        //         this.resetSetItem('languageType', 2);
        //     } else if (e == 3) {
        //         this.resetSetItem('languageType', 3);
        //         // localStorage.setItem('languageType', 3);
        //     }
        // },
        gwGetMenuList() {
            let params = {
                language: this.languageType
            };
            gwGetMenuList(params).then((res) => {
                // console.log('导航加载tree参数必填语言',res.obj)
                (this.headerMenus = res.obj.menuList),
                    (this.headerMenus_child = res.obj.menuList[1].children),
                    (this.serviceHotline = res.obj.serviceHotline);
            });
        }
    },
    created() {
        if (sessionStorage.getItem('languageType')) {
            this.languageType = sessionStorage.getItem('languageType');
        }
        this.gwGetMenuList();
        if (this.languageType == 1) {
            this.checked1 = 'checked';
            this.checked2 = '';
            this.checked3 = '';
            this.languageline="中文"
        } else if (this.languageType == 2) {
            this.checked2 = 'checked';
            this.checked1 = '';
            this.checked3 = '';
            this.languageline="English"
        } else {
            this.checked3 = 'checked';
            this.checked1 = '';
            this.checked2 = '';
            this.languageline="русский язык"
        }
        window.addEventListener('setItem', () => {
            this.languageType = sessionStorage.getItem('languageType');
            this.gwGetMenuList();
            if (this.languageType == 1) {
                this.checked1 = 'checked';
                this.checked2 = '';
                this.checked3 = '';
            } else if (this.languageType == 2) {
                this.checked2 = 'checked';
                this.checked1 = '';
                this.checked3 = '';
            } else {
                this.checked3 = 'checked';
                this.checked1 = '';
                this.checked2 = '';
            }
        });
    },
    computed: {
        onRoutes() {
            if (this.$route.meta.title == '工程案例') {
                return 'operation';
            } else if (this.$route.meta.title == '产品中心') {
                return 'product';
            } else {
                return this.$route.path.replace('/', '');
            }
        }
    }
};
</script>
<style scoped lang="less">
@deep: ~'>>>';
.header {
    @media screen and (max-width: 1700px) {
        // justify-content: space-evenly;
        // padding:.1875rem;
    }
    @media screen and (min-width: 1701px) {
        // padding: 0 5%;
        // justify-content: space-between;
    }
}
.header {
    justify-content: space-around;
    width: 100%;
    height: 1rem;
    box-sizing: border-box;
    box-shadow: 0 .0125rem .0125rem #e6e6e6;
    position: sticky;
    top: 0px;
    left: 0px;
    z-index: 999;
    background-color: #fff;
    color: #023e7a;
    display: flex;
    // flex-wrap: wrap;
    align-items: center;
    .title {
        position: absolute;
        left: 1.25rem;
        top: .1125rem;
        display: flex;
        justify-content: center;
        align-items: center;
        img {
            height: .525rem;
        }
        .title_info {
            width: 5.375rem;
            font-family: cursive;
            margin-left: .125rem;
            font-size: .3rem;
            font-weight: bold;
            .compEng {
                font-size: .225rem;
                font-family: monospace;
            }
        }
        .cursors {
            width: 2.5625rem;
            height: .75rem;
            text-align: center;
            border: .0187rem solid #2f5597;
            border-radius: .125rem;
            display: flex;
            flex-wrap: wrap;
            align-items: center;
            justify-content: center;
            align-content: center;
        }
        .cursors:hover {
            cursor: pointer;
            color: #9f0505;
            border: .0187rem solid #9f0505;
        }
    }
    .language_box span {
        margin-right: .375rem;
    }
    .header-right {
        display: flex;
        align-items: center;
        justify-content: space-between;
        position: absolute;
        top: 0;
        right: .5rem;
        width: 48%;
        // .contactNum {
        //     width: 3.875rem;
        //     display: flex;
        //     justify-content: center;
        //     align-items: flex-end;
        //     flex-wrap: wrap;
        //     margin-top: .25rem;
        //     position: relative;
        //     img {
        //         width: .4375rem;
        //         height: .4375rem;
        //     }
        //     .num {
        //         display: flex;
        //         justify-content: center;
        //         align-items: flex-end;
        //         margin-left: .0625rem;
        //     }
        //     .language_box {
        //         // position: absolute;
        //         font-size: .15rem;
        //         top: -0.1rem;
        //         right: .225rem;
        //         color: #000;
        //         span {
        //             margin: 0 .1rem;
        //         }
        //         span:hover {
        //             color: #9f0505;
        //             cursor: pointer;
        //         }
        //     }
        // }
    }
}

.header .el-menu-item {
    cursor: pointer;
    font-size: .2rem;
    padding: 0 .25rem;
    min-width: 1.375rem;
    text-align: center;
}
.el-menu.el-menu--horizontal {
    border: none;
}
.el-menu--horizontal > .el-menu-item {
    color: #333333;
    height: 1rem;
    line-height: 1rem;
}
.el-menu--horizontal > .el-menu-item.is-active {
    border-bottom: .025rem solid #023e7a;
    color: #023e7a;
    background-color: rgba(255, 255, 255, 0) !important;
}
.el-menu--horizontal > .el-menu-item.is-disabled:hover,
.el-menu-item:hover {
    border-color: transparent;
    border-bottom: .025rem solid #023e7a !important;
    color: #023e7a !important;
    background-color: rgba(255, 255, 255, 0) !important;
}

@{deep}.el-menu-item.is-disabled {
    opacity: 1;
}
.checked {
    color: #9f0505;
}
// 顶部导航展开动画
.bounce-in-enter-active {
    transition: all 0.3s ease;
    transition-delay: 0.2s;
}
.slide-fade-leave-active {
    transition: all 0.8s cubic-bezier(1, 0.5, 0.8, 1);
}
.bounce-in-enter,
.bounce-in-leave-to {
    transform: translateX(-1.25rem);
    opacity: 0;
}
.el-dropdown {font-size: .175rem;height: .5rem;line-height:.55rem}
@keyframes bounce-in {
    0% {
        transform: scale(0);
    }

    50% {
        transform: scale(1.5);
    }

    100% {
        transform: scale(1);
    }
}
.el-dropdown-link {
    cursor: pointer;
}
.el-icon-arrow-down {
    font-size: .15rem;
}
</style>
